import { SelectionGedcomVersion, SelectionGedcomForm, SelectionAny } from './internal';
export class SelectionGedcomFile extends SelectionAny {
    getVersion() {
        return this.get("VERS" /* Tag.Version */, null, SelectionGedcomVersion);
    }
    getGedcomForm() {
        return this.get("FORM" /* Tag.Format */, null, SelectionGedcomForm);
    }
}
//# sourceMappingURL=SelectionGedcomFile.js.map